import { all, takeLatest, call, put } from 'redux-saga/effects';
import apiPortalService from '@/services/api-portal';
import { ActionType } from 'deox';
import { ReloadType } from '@/types';
import {
  getDefaultApisActions,
  reloadDefaultEntityActions,
  fetchApiDocsActions,
  fetchAppsInfoActions,
} from '../actions';

export function* getDefaultApisSaga(action: ActionType<typeof getDefaultApisActions.request>) {
  try {
    const { organisationId } = action.payload;
    yield call(apiPortalService.getDefaultApis, organisationId);

    yield put(getDefaultApisActions.success());
  } catch (err) {
    yield put(getDefaultApisActions.failure(err));
  }
}

export function* reloadDefaultEntitySaga(
  action: ActionType<typeof reloadDefaultEntityActions.request>,
) {
  try {
    const { organisationId, type } = action.payload;
    yield call(apiPortalService.reloadDefaultEntity, organisationId, type);
    if (type === ReloadType.api) {
      yield put(fetchApiDocsActions.request(organisationId));
    } else if (type === ReloadType.app) {
      yield put(fetchAppsInfoActions.request(organisationId));
    }
    yield put(reloadDefaultEntityActions.success());
  } catch (err) {
    yield put(reloadDefaultEntityActions.failure(err));
  }
}

export default function* root() {
  yield all([takeLatest(getDefaultApisActions.request.type, getDefaultApisSaga)]);
  yield all([takeLatest(reloadDefaultEntityActions.request.type, reloadDefaultEntitySaga)]);
}
